// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import store from './store';
import router from './router';
import theme from '../static/theme';
import './permission'; // permission control
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/styles/element-variables.scss';
import locale from 'element-ui/lib/locale/lang/zh-CN';
import jm from 'vue-jsmind';

import 'swiper/dist/css/swiper.min.css';
import 'swiper/dist/js/swiper.min';

import '@/styles/index.scss'; // global css
import * as filters from './filters'; // global filters
import '@babel/polyfill';

// set ElementUI lang to EN
Vue.use(ElementUI, { locale });
Vue.use(jm);
if (window.jsMind) {
  Vue.prototype.jsMind = window.jsMind;
}
// 如果想要中文版 element-ui，按如下方式声明
// Vue.use(ElementUI)
Vue.prototype.$theme = theme;
Vue.config.productionTip = false;

// 锚点
Vue.directive('anchor', {
  inserted: function (el, binding) {
    el.onclick = function () {
      if (binding.value === 'risk-t' || binding.value === 'company-t') {
        $('.company-detail-body').animate({scrollTop: 1}, 0);
        setTimeout(() => {
          let scrollTops = 0;
          if (binding.value === 'risk-t') {
            scrollTops = $('#anchor-risk').attr('scroll-top');
          } else if (binding.value === 'company-t') {
            scrollTops = $('#anchor-company').attr('scroll-top');
          }
          $('.company-detail-body').animate({scrollTop: Number(scrollTops) + 1}, 300);
        }, 10);
      } else {
        let scrollTops = $('#anchor-' + binding.value).attr('scroll-top');
        $('.company-detail-body').animate({scrollTop: Number(scrollTops) + 1}, 300);
      }
    };
  }
});

// element-ui表格横向拖拽
Vue.directive('tableDrag', {
  inserted: function (el) {
    el = el.getElementsByClassName('el-table__body-wrapper')[0];
    el.style.cursor = 'grab';
    el.onmousedown = function () {
      let gapX = event.clientX;
      let startX = el.scrollLeft;
      document.onmousemove = function (e) {
        let x = e.clientX - gapX;
        el.scrollLeft = startX - x;
        return false;
      };
      document.onmouseup = function (e) {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    };
  }
});

// 过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  if (isChunkLoadFailed) {
    window.location.reload();
  } else {
    console.log(error);
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js